import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const ButtonGroupPrimary = ({ element, children, className, ...rest }) => {
  const Element = element
  return (
    <Element
      {...rest}
      className={classnames(className, 'ln-c-button-group__primary')}
    >
      {children}
    </Element>
  )
}

ButtonGroupPrimary.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.string,
  ]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

ButtonGroupPrimary.defaultProps = {
  element: 'div',
  className: undefined,
}

ButtonGroupPrimary.displayName = 'ButtonGroupPrimary'

export default ButtonGroupPrimary
